import { makeGetRequest, makePostRequest } from '../helpers/api'
import { configWithAuth } from '../helpers'

function configWithAuthBlob() {
    const config = configWithAuth()
    config.responseType = 'blob'
    return config
}

// Service layer for CourseGroupControllerV2 endpoints
// Base route: api/course/group/v2
export const studentCourseService = {
    // POST api/course/group/v2/{courseGroupId}/l1
    setCourseGroupL1: (courseGroupId, l1Id) =>
        makePostRequest(
            `course/group/v2/${courseGroupId}/l1`,
            JSON.stringify({ courseGroupId, l1Id }),
            configWithAuth()
        ),

    // GET api/course/group/v2?deviceId=xxx
    getCourseGroupOverview: (deviceId) => {
        const query = deviceId ? `?deviceId=${encodeURIComponent(deviceId)}` : ''
        return makeGetRequest(`course/group/v2${query}`, configWithAuth())
    },

    // GET api/course/group/v2/{courseGroupId}/l1/{l1Id}
    getCourseGroupById: (courseGroupId, l1Id) =>
        makeGetRequest(`course/group/v2/${courseGroupId}/l1/${l1Id}`, configWithAuth()),

    // GET api/course/group/v2/{courseGroupId}/l1/{l1Id}/progression
    getCourseGroupProgression: (courseGroupId, l1Id) =>
        makeGetRequest(`course/group/v2/${courseGroupId}/l1/${l1Id}/progression`, configWithAuth()),

    // GET api/course/group/v2/{courseGroupId}/l1/{l1Id}/course/{topicId}/lesson/order
    getCourseLessonOrder: (courseGroupId, l1Id, topicId) =>
        makeGetRequest(
            `course/group/v2/${courseGroupId}/l1/${l1Id}/course/${topicId}/lesson/order`,
            configWithAuth()
        ),

    // GET api/course/group/v2/{courseGroupId}/l1/{l1Id}/course/{topicId}/lesson/order/progression
    getCourseLessonOrderProgression: (courseGroupId, l1Id, topicId) =>
        makeGetRequest(
            `course/group/v2/${courseGroupId}/l1/${l1Id}/course/${topicId}/lesson/order/progression`,
            configWithAuth()
        ),

    // GET api/course/group/v2/{courseGroupId}/l1/{l1Id}/course/{topicId}/lesson/{customLessonId}/scenario/v1/
    getLesson: (courseGroupId, l1Id, topicId, customLessonId, generationIndex) => {
        const query = generationIndex !== undefined && generationIndex !== null
            ? `?generationIndex=${generationIndex}`
            : ''
        return makeGetRequest(
            `course/group/v2/${courseGroupId}/l1/${l1Id}/course/${topicId}/lesson/${customLessonId}/scenario/v1/${query}`,
            configWithAuth()
        )
    },

    // POST api/course/group/v2/{courseGroupId}/l1/{l1Id}/course/{topicId}/lesson/{customLessonId}/scenario/v3/
    reportLesson: (courseGroupId, l1Id, topicId, customLessonId, scenarioReport) =>
        makePostRequest(
            `course/group/v2/${courseGroupId}/l1/${l1Id}/course/${topicId}/lesson/${customLessonId}/scenario/v3/`,
            JSON.stringify(scenarioReport),
            configWithAuth()
        ),

    // GET api/image/file/{fileReferenceId} — Fetch image as blob via student endpoint
    // imageUrl format from DTOs: "image/file/{fileReferenceId}"
    fetchImage: (imageUrl) => makeGetRequest(imageUrl, configWithAuthBlob()),

    // GET api/sound/file/{fileReferenceId} — Fetch audio as blob via student endpoint
    // audioUrl format from DTOs: "sound/file/{fileReferenceId}"
    fetchAudio: (audioUrl) => makeGetRequest(audioUrl, configWithAuthBlob()),
}
